import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DestroyNotifierComponent } from 'src/app/core/component/destroy/destroy-notifier.component';
import { AutoCompleteItem } from '../../../../shared/auto-complete/interfaces/autocomplete-item';
import { ConfirmationModal } from '../../../../shared/confirmation-modal/interfaces/confirmation.modal';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { RosterPreviewModalComponent } from '../roster-preview-modal/roster-preview-modal.component';

@Component({
  selector: 'app-roster-group-upload',
  templateUrl: './roster-group-upload.component.html'
})
export class RosterGroupUploadComponent extends DestroyNotifierComponent implements OnInit {
  @Input() form: UntypedFormGroup | undefined;

  totalMembersCount = 0;
  constructor(
      private translate: TranslateService,
      private modalService: BsModalService
  ) {
    super();
  }

  ngOnInit() {
    const calculateTotalStudentCount = (value: Array<AutoCompleteItem>) => {
      let totalCount = 0;
      value.forEach((item: AutoCompleteItem) => {
        totalCount += Number(item.extraLabels.metaDataCount);
      });
      this.totalMembersCount = totalCount;
    };

    const groupSelectValue: any = this.form?.get('groupSelect')?.value;

    if (groupSelectValue) {
      calculateTotalStudentCount(groupSelectValue);
    }

    this.form?.get('groupSelect')?.valueChanges.subscribe(calculateTotalStudentCount);
  }

  async onRosterClick(rosterAutoCompleteItem: AutoCompleteItem){
    const translations = await this.translate.get(['PREVIEW_GROUP', 'CLOSE']).toPromise();

    const initialState = {
      modal: {
        uuid: rosterAutoCompleteItem.value,
        title: translations.PREVIEW_GROUP,
        secondaryButtonText: translations.CLOSE
      } as ConfirmationModal
    };

    this.modalService.show(RosterPreviewModalComponent, {
      initialState,
      class: 'modal-md'
    });
  }
}
